import React from 'react';
import {Container, Row, Col} from 'reactstrap';

import '../debtPayment.scss';
import BasicText from './basicText';
import BasicImage from './basicImage';

const UpdatePaymentMethodNotification = (props) => {
  const arrow = require(`../images/icons-arrow${props.isPrivate ? '-private' : ''}.svg`);

  return (
    <Container className='debtpayment-notification-container'>
      <Row>
        <Col>
          <BasicText text='רגע, זה חשוב' bold />
        </Col>
      </Row>
      <Row>
        <Col>
          <BasicText text='זיהינו שיש לכם אמצעי תשלום שצריך לעדכן' />
        </Col>
      </Row>
      <Row onClick={props.updatePaymentMethod}>
        <Col className='debtpayment-contactus-button'>
          <BasicText text={'לעדכון אמצעי התשלום'} bold color={props.isPrivate ? 'privatePink' : 'businessPurple'} />
          <BasicImage src={arrow} classname='arrow-img' />
        </Col>
      </Row>
    </Container>
  );
};

export default UpdatePaymentMethodNotification;
